<template>
    <div class="counter">
        <div class="counter__button counter__button_left" @click="decrement">
            <span class="lnr lnr-chevron-left"></span>
        </div>
        <input type="text" v-model="num" disabled />
        <div class="counter__button counter__button_right" @click="increment">
            <span class="lnr lnr-chevron-right"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: ['getNumCb', 'defaultNum'],
    methods: {
        increment() {
            this.num++

        },
        decrement() {
            this.num--
        }
    },
    computed: {
        num: {
            set(val) { this.$props.getNumCb(val) },
            get() { return this.$props.defaultNum }
        }
    }
}
</script>

<style lang="sass" scoped>
@use 'styles/global-variables.sass'

$btn-radius: 5px

.counter
    display: inline-block
    font-size: 0
    user-select: none
    &__button
        display: inline-block
        vertical-align: top
        width: 25px
        height: 25px
        background-color: rgb(30, 139, 195)
        color: #fff
        font-size: 14px
        text-align: center
        padding-top: 4px
        cursor: pointer
        &_left
            border-top-left-radius: $btn-radius
            border-bottom-left-radius: $btn-radius
        &_right
            border-top-right-radius: $btn-radius
            border-bottom-right-radius: $btn-radius
    input
        font-size: 14px
        height: 25px
        vertical-align: top
        display: inline-block
        border: 1px solid rgb(30, 139, 195)
        width: 50px
        text-align: center
</style>